import { AxiosRequestConfig } from "axios";

export const postLoginConfig: AxiosRequestConfig = {
  method: "post",
  url: "/user/auth",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};
